import React from 'react';
import PublicPage from '../../components/public/PublicPage';
import { PHONE_DISPLAY, SUPPORT_EMAIL } from '../../publicSite/config';

export default function AdmissionsContact() {
  return (
    <PublicPage
      meta={{
        title: 'Admissions Contact | School of Shem',
        description: 'Contact admissions for enrollment questions and support.'
      }}
      hero={{
        eyebrow: 'Admissions',
        title: 'Contact Admissions',
        subtitle: 'Reach out for guidance on cohorts, requirements, and onboarding.'
      }}
      sections={[
        {
          title: 'Admissions support',
          subtitle: 'We will help you find the right pathway.',
          cards: [
            { title: 'Email', description: SUPPORT_EMAIL },
            { title: 'Phone / WhatsApp', description: PHONE_DISPLAY },
            { title: 'Response time', description: 'Within 1-2 business days.' }
          ]
        }
      ]}
    />
  );
}
